/**
 * Utils2
 * 工具包
 * Version 1.0.1
 */
;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.utils = factory(root);
    }
}(this, function (window) {
    var _root = {
        testType_Types: [],
        lock_data: {}
    };

    //region magic
    var _magicArray = {
        _new: function (array) {
            var self = this;
            _u.each(array || [], function (obj) {
                self.valueOf().push(obj);
            });

            Object.defineProperties(this, {
                each: {
                    value: _magicArray.each.bind(this),
                    enumerable: false
                },
                append: {
                    value: _magicArray.append.bind(this),
                    enumerable: false
                },
                group: {
                    value: _magicArray.group.bind(this),
                    enumerable: false
                },
                distinct: {
                    value: _magicArray.distinct.bind(this),
                    enumerable: false
                },
                select: {
                    value: _magicArray.select.bind(this),
                    enumerable: false
                },
                pack: {
                    value: _magicArray.pack.bind(this),
                    enumerable: false
                },
                take: {
                    value: _magicArray.take.bind(this),
                    enumerable: false
                },
                skip: {
                    value: _magicArray.skip.bind(this),
                    enumerable: false
                },
                normalize: {
                    value: _magicArray.normalize.bind(this),
                    enumerable: false
                }
            });
            // this["each"] = _magicArray.each.bind(this);
            // this["append"] = _magicArray.append.bind(this);
            // this["group"] = _magicArray.group.bind(this);
            // this["distinct"] = _magicArray.distinct.bind(this);
            // this["select"] = _magicArray.select.bind(this);
            // this["pack"] = _magicArray.pack.bind(this);
            // this["take"] = _magicArray.take.bind(this);
            // this["skip"] = _magicArray.skip.bind(this);
            // this["normalize"] = _magicArray.normalize.bind(this);
        },
        _instanceof: function (obj) {
            return obj instanceof _magicArray._new;
        },
        _getType: function () {
            return "[object Array:magicArray]";
        },

        /**
         * 遍历，在 callback 中使用 return true; 会中止遍历
         * @param callback 处理，function (object,index)
         */
        each: function (callback) {
            return _u.each(this, callback);
        },

        /**
         * 全部追加
         * @param object 数组则追加内所有元素，对象则追加内所有值
         * @returns {_magicArray}
         */
        append: function (object) {
            var self = this;
            _u.each(object, function (obj) {
                self.push(obj);
            });

            return this;
        },

        /**
         * 分组
         * @param keyExpression 组名处理表达式，function (object)，返回分组名
         * @returns {*}
         */
        group: function (keyExpression) {
            var container = {};

            if (!keyExpression || !_u.isType(keyExpression, _u.types.function))
                return this;

            _u.each(this, function (obj) {
                var key = keyExpression(obj);

                if (container[key]) {
                    container[key].results = container[key].results || [];
                    container[key].results.push(obj);
                } else {
                    container[key] = {
                        key: key,
                        results: [obj]
                    };
                }
            });

            return container;
        },

        /**
         * 去重
         * @param expression 处理表达式，function (object)，返回唯一标识
         * @returns {*}
         */
        distinct: function (expression) {
            var container = {};

            if (!expression || !_u.isType(expression, _u.types.function))
                return this;

            _u.each(this, function (obj) {
                var identify = expression(obj);

                if (!container[identify])
                    container[identify] = obj;
            });

            return new _magicArray._new(_magicObject.toArray.call(container));
        },

        /**
         * 投影
         * @param expression 处理表达式，function (object)，返回所需对象
         * @returns {_new}
         */
        select: function (expression) {
            var array = new _magicArray._new();

            _u.each(this, function (obj) {
                var result = expression(obj);

                if (result !== undefined)
                    array.push(result);
            });

            return array;
        },

        /**
         * 打包
         * @param expression 处理表达式，function (object)，返回所需对象，注意：(null,function,regexp,symbol,error不会被计入)
         * @returns {_new}
         */
        pack: function (expression) {
            var array = new _magicArray._new();

            _u.each(this, function (obj) {
                var result = expression(obj);
                var resultType = _u.getType(result);

                if (
                    resultType !== _u.types.undefined &&
                    resultType !== _u.types.null &&
                    resultType !== _u.types.function &&
                    resultType !== _u.types.regexp &&
                    resultType !== _u.types.symbol &&
                    resultType !== _u.types.error
                ) {
                    if (_magicArray._instanceof(result) || _u.isType(result, _u.types.array)) {
                        _u.each(result, function (child) {
                            array.push(child);
                        });
                    } else {
                        array.push(result);
                    }
                }
            });

            return array;
        },

        /**
         * 跳过
         * @param option 数字：跳过个数；表达式：function (object)，返回是否结束跳过，跳过从0到表达式返回true部分的值
         * @returns {*}
         */
        skip: function (option) {
            var array = null;

            if (_u.isType(option, _u.types.number)) {
                array = new _magicArray._new();
                for (var i = option < 0 ? 0 : option; i < this.length; i++) {
                    array.push(this[i]);
                }
            }
            else if (_u.isType(option, _u.types.function)) {
                array = new _magicArray._new();
                var matched = false;
                _u.each(this, function (obj) {
                    if (matched)
                        array.push(obj);
                    else {
                        if (option(obj))
                            matched = true;
                    }
                });
            }

            if (array)
                return array;
            else
                return this;
        },

        /**
         * 提取
         * @param num 对象个数
         * @returns {_new}
         */
        take: function (num) {
            return new _magicArray._new(this.slice(0, num));
        },

        /**
         * 转换成数组
         * @param deep 深度转换（将数组内所有magicArray全部常规化）
         * @returns {Array}
         */
        normalize: function (deep) {
            var array = [];

            _u.each(this, function (obj) {
                array.push(
                    deep && obj["normalize"] ? obj["normalize"]() : obj
                );
            });

            return array;
        },

        /**
         * 转换成数组（无长度返回默认值）
         * @param defaultValue 默认值
         * @param deep 深度转换（将数组内所有magicArray全部常规化）
         * @returns {*}
         */
        valOrDefault: function (defaultValue, deep) {
            if (this.length <= 0)
                return defaultValue;
            else
                return this.normalize(deep)
        }
    };
    var _magicObject = {
        _new: function (obj) {
            this.valueOf()["_"] = obj;

            this["each"] = _magicObject.each.bind(this);
            this["toArray"] = _magicObject.toArray.bind(this);
        },
        _instanceof: function (obj) {
            return obj instanceof _magicObject._new;
        },
        _getType: function () {
            return "[object Object:magicObject]";
        },

        /**
         * 遍历，在 callback 中使用 return true; 会中止遍历
         * @param callback 处理，function (object,key)
         */
        each: function (callback) {
            return _u.each(this._, callback);
        },

        /**
         * 转换成数组
         * @param expression 处理表达式（可选），function (obj)，返回所需对象
         * @returns {Array}
         */
        toArray: function (expression) {
            var array = [];

            _u.each(this, function (obj) {
                array.push(expression ? expression(obj) : obj);
            });

            return array;
        }
    };
    _magicArray._new.prototype = [];
    _magicObject._new.prototype = {};
    _root.testType_Types.push(_magicArray);
    _root.testType_Types.push(_magicObject);
    //endregion

    //region publish and subscribe
    // {
    //     id: 1,
    //     properties: {
    //         propA: [],
    //         propB: []
    //     }
    // }
    var _publishAndSubscribe = {
        latestId: 0,
        subscribers: {},
        notify: function (publisherId, propertyName, before, current) {
            if (before === current)
                return;

            var publisher = _publishAndSubscribe.subscribers[publisherId];
            if (!publisher)
                return;

            var property = publisher.properties[propertyName];
            if (!property)
                return;

            _u.each(property, function (callback) {
                if (!!callback)
                    callback({
                        propertyName: propertyName,
                        before: before,
                        current: current
                    });
            });
        }
    };
    //endregion

    var _u = {
        types: {
            "function": "[object Function]",
            "array": "[object Array]",
            "string": "[object String]",
            "number": "[object Number]",
            "boolean": "[object Boolean]",
            "regexp": "[object RegExp]",
            "date": "[object Date]",
            "symbol": "[object Symbol]",
            "error": "[object Error]",
            "object": "[object Object]",
            "undefined": "[object Undefined]",
            "null": "[object Null]",
        },

        // =================== Tiny Modules ===================

        /**
         * 状态锁
         */
        lock: {
            /**
             * 锁住状态
             * @param key 键
             * @param value 存储值
             */
            hold: function (key, value) {
                _root.lock_data[key] = (value != null ? value : true);
            },

            /**
             * 释放状态
             * @param key 键
             */
            release: function (key) {
                delete _root.lock_data[key];
            },

            /**
             * 检查是否锁住
             * @param key 键
             * @returns {boolean}
             */
            check: function (key) {
                return _root.lock_data[key] != null;
            },

            /**
             * 获取存储值
             * @param key 键
             * @returns {*}
             */
            get: function (key) {
                return _root.lock_data[key];
            }
        },

        // =================== Methods ===================

        /**
         * 获取参数的类型文本，基于 Object.prototype.toString.call()
         * @param value 需要获取类型的对象
         * @returns {*}
         */
        getType: function (value) {
            return Object.prototype.toString.call(value);
        },

        /**
         * 测试参数的类型文本，优先根据在库内注册的类型作为依据
         * @param value 需要获取类型的对象
         * @returns {*}
         */
        testType: function (value) {
            var typeText = null;

            _u.each(_root.testType_Types, function (type) {
                if (type["_instanceof"] && type["_getType"] && type["_instanceof"](value)) {
                    typeText = type["_getType"]();
                    return true;
                }
            });

            if (!typeText) {
                typeText = this.getType(value);
            }

            return typeText;
        },

        /**
         * 判断是否是目标类型
         * @param value 目标对象
         * @param type 类型文本（或直接使用 utils.types）
         * @returns {boolean}
         */
        isType: function (value, type) {
            return this.getType(value) === type;
        },

        /**
         * 遍历目标，如果是对象则遍历对象内属性，在 callback 中使用 return true; 会中止遍历
         * @param source 目标对象
         * @param callback 处理，function (object,indexOrKey)
         */
        each: function (source, callback) {
            if (source) {
                var hasCallback = !!callback;

                if ((this.isType(source, this.types.array) && source.length > 0) || (_magicArray._instanceof(source))) {
                    for (var i = 0; i < source.length; i++) {
                        if (hasCallback)
                            if (callback(source[i], i))
                                break;
                    }
                } else if (this.isType(source, this.types.object)) {
                    var index = 0;
                    var keys = Object.keys(source);
                    for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        if (hasCallback) {
                            if (callback(source[key], index))
                                break;
                            else
                                index++;
                        }
                    }
                }
            }
        },

        /**
         * 遍历目标，根据方法筛选目标并返回结果集
         * @param source 目标对象
         * @param expression 表达式，function (object)
         * @returns {*}
         */
        find: function (source, expression) {
            if (this.isType(source, this.types.array) && this.isType(expression, this.types.function)) {
                var results = [];

                _u.each(source, function (obj) {
                    if (expression(obj))
                        results.push(obj);
                });

                return results;
            }

            return null;
        },

        /**
         * 生成最低为1的随机数
         * @param max 最大值
         * @returns {number}
         */
        random: function (max) {
            return Math.ceil(Math.random() * max);
        },

        /**
         * 从类 URL 字符串中提取参数
         * @param name 参数名
         * @param url 类 URL 字符串，在浏览器环境不填则使用 window.location.href
         * @returns {*}
         */
        url: function (name, url) {
            //http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
            if (!url)
                url = window ? window.location.href : "";
            name = name.replace(/[\[\]]/g, "\\$&");

            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
            var results = regex.exec(url);

            if (!results)
                return null;
            if (!results[2])
                return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        /**
         * 对对象进行额外扩展
         * @param object
         * @returns {_new}
         */
        magic: function (object) {
            var _objType = this.getType(object);

            if (_objType === this.types.object) {
                return new _magicObject._new(object);
            } else if (_objType === this.types.array) {
                return new _magicArray._new(object);
            }

            return object;
        },

        /**
         * 发布对象（用于订阅）
         * @param object 对象
         * @param propertyName 属性名
         * @param skipTypeCheck 跳过属性名类型检查
         * @returns {number} 发布者ID
         */
        publish: function (object, propertyName, skipTypeCheck) {
            if (!skipTypeCheck && _u.isType(propertyName, _u.types.array)) {//如果属性名多个则批量处理
                if (propertyName.length < 1) {//检查个数
                    return -1;
                }

                _u.each(propertyName, function (name) {
                    _u.publish(object, name, true);
                });
                return object.__u2_publisherId;
            }

            var prop = Object.getOwnPropertyDescriptor(object, propertyName);
            if (prop && (prop.get || prop.set)) {
                return -1;
            }

            var pubId = object.__u2_publisherId || ++_publishAndSubscribe.latestId;
            if (!object.__u2_publisherId)
                object.__u2_publisherId = pubId;

            var before, current = object[propertyName];
            Object.defineProperty(object, propertyName, {
                get: function () {
                    return current;
                },
                set: function (v) {
                    before = current;
                    current = v;

                    _publishAndSubscribe.notify(pubId, propertyName, before, current);
                }
            });

            return pubId;
        },

        /**
         * 订阅对象
         * @param publisherInfo 发布者信息（发布者对象或发布者ID）
         * @param propertyName 订阅的属性
         * @param callback 发布通知时的响应，function (info)
         */
        subscribe: function (publisherInfo, propertyName, callback) {
            var publisherInfoType = _u.getType(publisherInfo);
            if (
                publisherInfoType !== _u.types.number &&
                publisherInfoType !== _u.types.object &&
                !_u.isType(callback, _u.types.function)
            )//抛弃无效输入
                return;

            var pubId = _u.isType(publisherInfo, _u.types.number) ? publisherInfo : (publisherInfo ? publisherInfo.__u2_publisherId : -1);
            if (pubId < 1)//抛弃无效输入
                return;

            var publisher = _publishAndSubscribe.subscribers[pubId];
            if (!publisher) {
                publisher = {
                    id: pubId,
                    properties: {}
                };
                _publishAndSubscribe.subscribers[pubId] = publisher;
            }

            if (!publisher.properties[propertyName]) {
                publisher.properties[propertyName] = [callback];
            } else {
                publisher.properties[propertyName].push(callback);
            }
        },

        /**
         * 取消订阅对象
         * @param publisherInfo 发布者信息（发布者对象或发布者ID）
         * @param propertyName 取消订阅的属性
         * @param theCallback 订阅时的通知对象
         */
        unsubscribe: function (publisherInfo, propertyName, theCallback) {
            var publisherInfoType = _u.getType(publisherInfo);
            if (
                publisherInfoType !== _u.types.number &&
                publisherInfoType !== _u.types.object &&
                !_u.isType(callback, _u.types.function)
            )//抛弃无效输入
                return;

            var pubId = _u.isType(publisherInfo, _u.types.number) ? publisherInfo : (publisherInfo ? publisherInfo.__u2_publisherId : -1);
            if (pubId < 1)//抛弃无效输入
                return;

            //检查值有效性
            var publisher = _publishAndSubscribe.subscribers[pubId];
            if (!publisher)
                return;
            var properties = publisher.properties[propertyName];
            if (!properties)
                return;

            //删除
            var index = -1;
            _u.each(properties, function (o, i) {
                if (o === theCallback) {
                    index = i;
                    return true;
                }
            });
            if (index > -1) {
                properties.splice(index, 1);
            }

            //释放空数组占用的内存
            if (properties.length === 0) {
                delete publisher.properties[propertyName];
            }
        },

        /**
         * 取消全部订阅
         * @param publisherInfo 发布者信息（发布者对象或发布者ID）
         * @param propertyName 取消订阅的属性
         * @returns {boolean} 操作状态
         */
        unsubscribeAll: function (publisherInfo, propertyName) {
            var publisherInfoType = _u.getType(publisherInfo);
            if (
                publisherInfoType !== _u.types.number &&
                publisherInfoType !== _u.types.object
            )//清除全部
            {
                _publishAndSubscribe.subscribers = {};
                return true;
            }

            var pubId = _u.isType(publisherInfo, _u.types.number) ? publisherInfo : (publisherInfo ? publisherInfo.__u2_publisherId : -1);
            var publisher = _publishAndSubscribe.subscribers[pubId];
            if (pubId < 1 || !publisher)//抛弃无效输入
                return false;

            if (!propertyName) {
                delete _publishAndSubscribe.subscribers[pubId];
                return true;
            }

            delete publisher.properties[propertyName];
            return true;
        },

        pnsDebug: function () {
            return _publishAndSubscribe;
        },

        safeParse: function (jsonString, reviewer) {
            try {
                return JSON.parse(jsonString, reviewer);
            } catch (e) {
                return undefined;
            }
        }
    };

    return _u;
}));